import { FC, useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { MenuItem as MenuItemType } from '../menuItems';
import styles from './MenuItem.module.scss';
import ItemWrapper from '../ItemWrapper/ItemWrapper';

type MenuItemProps = MenuItemType & {
  isSidebarOpen: boolean;
  isSubItem?: boolean;
  closeMobileMenu?: () => void;
};

const MenuItem: FC<MenuItemProps> = ({
  isSidebarOpen,
  label,
  icon,
  to,
  items,
  isSubItem,
  closeMobileMenu,
}) => {
  const location = useLocation();
  const currentPathName = location.pathname;
  const isActive = to === currentPathName;

  const hasSubItems = items && items.length > 0;

  const hasActiveSubItem =
    hasSubItems && items.some((item) => item.to === currentPathName);

  const [showSubItems, setShowSubItems] = useState(hasActiveSubItem);

  const toggleSubItems = () => setShowSubItems(!showSubItems);
  const canRenderSubItems = hasSubItems && showSubItems && isSidebarOpen;

  return (
    <>
      <li
        key={label}
        className={classNames(
          styles.menuItem,
          !isSidebarOpen && styles.centered,
          isSubItem && styles.subItem,
          isActive && styles.active
        )}
      >
        <ItemWrapper
          hasSubItems={hasSubItems}
          onClick={toggleSubItems}
          to={to}
          closeMobileMenu={closeMobileMenu}
        >
          {icon && (
            <div>
              <FontAwesomeIcon icon={icon} className={styles.itemIcon} />
            </div>
          )}
          {isSidebarOpen && (
            <>
              <span className={styles.label}>{label}</span>
              {hasSubItems && (
                <div className={styles.arrowIcon}>
                  <FontAwesomeIcon
                    icon={showSubItems ? faChevronUp : faChevronDown}
                  />
                </div>
              )}
            </>
          )}
        </ItemWrapper>
      </li>
      {canRenderSubItems && (
        <ul className={styles.subItemsList}>
          {items.map((subItem) => {
            return (
              <MenuItem
                key={subItem.label}
                label={subItem.label}
                icon={subItem.icon}
                to={subItem.to}
                isSidebarOpen={isSidebarOpen}
                items={subItem.items}
                isSubItem
                closeMobileMenu={closeMobileMenu}
              />
            );
          })}
        </ul>
      )}
    </>
  );
};

export default MenuItem;
